//Alertify
import 'alertifyjs/build/css/alertify.min.css'
import 'alertifyjs/build/css/themes/bootstrap.css'
import alertify from 'alertifyjs/build/alertify'
alertify.set('notifier', 'delay', 10)
alertify.set('notifier', 'position', 'bottom-left')

// Swiper. core version + navigation, pagination modules:
import Swiper, { Thumbs, FreeMode } from 'swiper'
// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import 'lazysizes'

// configure Swiper to use modules
Swiper.use([Thumbs, FreeMode])

//Vimeo
import Player from '@vimeo/player'

$(function () {
	if (
		document.querySelector('.crea--galeria .gallery-thumbs') &&
		document.querySelector('.crea--galeria .gallery')
	) {
		var galleryThumbnail = new Swiper('.crea--galeria .gallery-thumbs', {
			spaceBetween: 10,
			slidesPerView: 4,
			freeMode: true,
			watchSlidesProgress: true,
			width: '90px',
		})

		var gallery = new Swiper('.crea--galeria .gallery', {
			loop: true,
			speed: 1000,
			slidesPerView: 1,
			centeredSlides: true,
			spaceBetween: 20,
			thumbs: {
				swiper: galleryThumbnail,
			},
		})

		gallery.on('slideChangeTransitionEnd', function (swiper) {
			swiper.slides.forEach((slide) => {
				let vsa = slide.querySelector('.video_embed')
				let btn = slide.querySelector('button.play')

				if (vsa) {
					var p = new Player(vsa)

					p.getPaused().then(function (paused) {
						if (!paused) {
							p.pause()
								.then(function () {
									$(btn).removeClass('click')
									console.log('video pausado')
								})
								.catch(function (error) {
									console.log('video error', error)
								})
						}
					})
				}
			})
			var slide_active = swiper.slides[swiper.activeIndex]
			var video_slide_active = slide_active.querySelector('.video_embed')
			var btn_slide_active = slide_active.querySelector('button.play')
			if (video_slide_active) {
				let player = new Player(video_slide_active)
				player
					.play()
					.then(function () {
						$(btn_slide_active).addClass('click')
						console.log('video iniciado')
					})
					.catch(function (error) {
						console.log('video error', error)
					})
			}
		})
	}

	$('.item-video button.play').on('click', function () {
		var _this = this
		let video_slide_active = $(_this).siblings('.video_embed')
		video_slide_active = video_slide_active.length ? video_slide_active[0] : null

		if (video_slide_active) {
			let player = new Player(video_slide_active)

			player.getPaused().then(function (paused) {
				if (!paused) {
					player
						.pause()
						.then(function () {
							$(_this).removeClass('click')
							console.log('video pausado')
						})
						.catch(function (error) {
							console.log('video error', error)
						})
				} else {
					player
						.play()
						.then(function () {
							$(_this).addClass('click')
							console.log('video iniciado')
						})
						.catch(function (error) {
							console.log('video error', error)
						})
				}
			})
		}
	})

	/* btn compartir */
	$('.compartir').on('click', function (e) {
		$(this).next('section').toggleClass('activo')
	})

	$('.btn.contenido-completo').on('click', function (e) {
		e.preventDefault()

		window.top.location.href = this.href
	})

	$('#cultura-sostenible-form').on('submit', function (event) {
		event.preventDefault()

		let action = this.action
		$.post(
			action,
			$(this).serialize(),
			function (data, textStatus, jqXHR) {
				if (textStatus == 'success') {
					if (data && data.success) {
						alertify.success('Mensaje enviado')

						$('#cultura-sostenible-form').reset()
					} else {
						alertify.error('error: ' + data.msg)
					}
				} else {
					alertify.error('error: No hay respuesta del servidor')
				}
			},
			'json'
		)
	})
})
